var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_ddd_2362_57)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.9941,
    cy: 49,
    rx: 44.9936,
    ry: 45,
    fill: "#89B369"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6959 31.3055C73.1259 31.173 72.5374 31.14 71.9561 31.2077C69.1684 31.5301 67.1698 34.0512 67.492 36.8387C67.6426 38.1405 68.2902 39.3338 69.2998 40.1693L65.3451 46.3142C62.9857 44.7888 59.8362 45.4647 58.3105 47.8241C57.9764 48.3409 57.7386 48.9141 57.6091 49.5157L50.2799 46.2669C49.6912 43.521 46.9881 41.7724 44.2421 42.3613C41.4961 42.9501 39.7472 45.6533 40.3359 48.3991C40.4034 48.7138 40.5006 49.0214 40.6262 49.3177L36.5033 56.6516C34.1249 55.1617 30.9887 55.8819 29.4986 58.2604C28.0085 60.6388 28.7285 63.7748 31.107 65.2647C33.4854 66.7546 36.6216 66.0344 38.1117 63.6559C39.1162 62.0525 39.1469 60.0239 38.1911 58.3911L42.1637 51.325C44.3695 53.0615 47.5656 52.681 49.3022 50.4751C49.7023 49.967 50.0017 49.3871 50.1844 48.7668L57.7317 52.1121C58.4654 54.4381 60.7472 55.9157 63.1699 55.6339C63.4192 55.6049 63.6662 55.5578 63.9086 55.4929C66.6217 54.7571 68.2249 51.9614 67.4892 49.2484C67.3755 48.8289 67.2084 48.4257 66.9922 48.0486L71.3929 41.2107C74.1283 41.8465 76.8612 40.1445 77.4972 37.4093C78.1331 34.674 76.4312 31.9412 73.6959 31.3055ZM36.5444 60.6363C36.7222 62.1518 35.6376 63.5246 34.122 63.7023C32.6064 63.8801 31.2336 62.7957 31.0559 61.2802C30.8782 59.7647 31.9628 58.3918 33.4784 58.2141C33.4798 58.214 33.4812 58.2138 33.4826 58.2136C34.9965 58.0392 36.3662 59.1228 36.5444 60.6363ZM48.0504 47.0094C48.226 48.5239 47.1407 49.8942 45.6261 50.0699C44.1116 50.2456 42.7413 49.1605 42.5656 47.646C42.4082 46.2883 43.2677 45.0198 44.5872 44.6628C44.7187 44.6277 44.8526 44.6021 44.9878 44.5864C46.5021 44.4116 47.8723 45.4954 48.0504 47.0094ZM65.3245 50.2637C65.5001 51.7782 64.4148 53.1485 62.9003 53.3242C61.3857 53.4999 60.0155 52.4148 59.8398 50.9003C59.6823 49.5426 60.5421 48.2739 61.8616 47.9171C61.993 47.8819 62.1269 47.8563 62.2622 47.8407C63.7768 47.6643 65.1481 48.749 65.3245 50.2637ZM75.2863 35.9385C75.4634 37.4537 74.3784 38.8257 72.8632 39.0028C71.3479 39.18 69.9759 38.0952 69.7989 36.58C69.6218 35.0648 70.7068 33.6928 72.222 33.5157C72.2229 33.5156 72.2236 33.5155 72.2244 33.5154C73.739 33.3392 75.1099 34.424 75.2863 35.9385Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2362_57",
    x: 0.000488281,
    y: 0,
    width: 105.987,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2362_57"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.701961 0 0 0 0 0.411765 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2362_57",
    result: "effect2_dropShadow_2362_57"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.701961 0 0 0 0 0.411765 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2362_57",
    result: "effect3_dropShadow_2362_57"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2362_57",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.8558d9b80ff6a49809408b336e0749b3.svg";
export { ForwardRef as ReactComponent };